/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Quiet_Funny_Bulldog_MixInputs */

const fr_quiet_funny_bulldog_mix = /** @type {(inputs: Quiet_Funny_Bulldog_MixInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter un PB pour ${i?.name}`)
};

/**

* @param {Quiet_Funny_Bulldog_MixInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const quiet_funny_bulldog_mix = /** @type {((inputs: Quiet_Funny_Bulldog_MixInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Funny_Bulldog_MixInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_quiet_funny_bulldog_mix(inputs)
});